import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { ScrollToTop } from './components/ui/ScrollToTop';
import HomePage from './routes/HomePage';
import AboutPage from './routes/AboutPage';
import MissionPage from './routes/MissionPage';
import HowItWorksPage from './routes/HowItWorksPage';
import PricingPage from './routes/PricingPage';
import FAQPage from './routes/FAQPage';
import ContactPage from './routes/ContactPage';
import NotFoundPage from './routes/NotFoundPage';

const EventPage = lazy(() => import('./routes/EventPage'));
const UploadPage = lazy(() => import('./routes/UploadPage'));
const GalleryPage = lazy(() => import('./routes/GalleryPage'));

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-border border-t-accent" />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<Loading />}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/despre" element={<AboutPage />} />
        <Route path="/misiune" element={<MissionPage />} />
        <Route path="/cum-functioneaza" element={<HowItWorksPage />} />
        <Route path="/preturi" element={<PricingPage />} />
        <Route path="/intrebari-frecvente" element={<FAQPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/e/:slug" element={<EventPage />} />
        <Route path="/e/:slug/upload" element={<UploadPage />} />
        <Route path="/e/:slug/gallery" element={<GalleryPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}